module.exports = __webpack_public_path__ + "img/brand4.edf46b62.png";